$(document).ready(function() {
  $(document).ajaxSuccess(function(event, xhr, settings) {
    if ($(document).find('.ph-freetextsearch__wrapper').length > 0) {
      var completeUrl = settings.url,
          result = xhr.responseJSON,
          textValue = $(document).find('.ph-freetextsearch__input').val();

      if (completeUrl.includes('/orderSolrSearch/getSeachOrders')) {
        if (!$.isEmptyObject(result)) {
          $.each(result, function(key, orderData) {
            if (key !== null) {
              var markInstance = new Mark(document.querySelector('.ph-freetextsearch__data .context-' + key));
              var keywordInput = textValue;

              markInstance.unmark();

              if (keywordInput) {
                markInstance.mark(keywordInput, {
                  caseSensitive: false,
                  separateWordSearch: true,
                  exclude: ['button']
                });
              }
            }
          });
        }

        colorchangestatus();
      }

      if (completeUrl.includes('repair-product/getRepairOrders') && !$('.' + ACC.newRepairHistory.textSearchData).hasClass('ph-d-none')) {
        if (!$.isEmptyObject(result)) {
          $.each(result.repairOrderDataList, function(key, orderData) {
            if (key !== null) {
              var markInstance = new Mark(document.querySelector('.ph-myrepairs-searchData .context-' + orderData.repairRequestId));
              var keywordInput = textValue;

              markInstance.unmark();

              if (keywordInput) {
                markInstance.mark(keywordInput, {
                  caseSensitive: false,
                  separateWordSearch: true,
                  exclude: ['button']
                });
              }
            }
          });
        }
      }

    }
  });

  $('.ph-freetextsearch__input').on('keyup', $.debounce(700, false,  function(){
    var textValue = $(document).find('.ph-freetextsearch__input').val(),
        markInstance = new Mark(document.querySelectorAll('.ph-helptopicscategories_questiontitle, .ph-helptopicscategories_answerdescription'));

    markInstance.unmark();
    $('.ph-supportHub__searchResult').html('0');
    $(".ph-helptopicscategories_questiontitle").removeClass('hidden');
    $(".ph-helptopicscategories_answerdescription").addClass('hidden');
    $(".ph-supporthub__searchbottom").removeClass('hidden');
    
    if (textValue.length === 0) {
      $('.ph-helptopicscategories__boxes').removeClass('hidden');
      $('.ph-helptopicscategories__questions').addClass('hidden');
      $(".ph-supporthub__searchbottom").addClass('hidden');
    }
    
    if (textValue) {
      markInstance.mark(textValue, {
        caseSensitive: false,
        separateWordSearch: true,
        exclude: ['button'],
        done : function(mark){
          if (mark > 0) {
            $('.ph-supportHub__searchResult').html(mark);
            $('.ph-helptopicscategories__boxes').addClass('hidden');
            $('.ph-helptopicscategories_back').addClass('hidden');
            $('.ph-helptopicscategories_categoryname').addClass('hidden');
            $(".ph-helptopicscategories__parent").find('.ph-profilepage__horizontalline').addClass('hidden');
            $(".ph-helptopicscategories__parent").find('.ph-profilepage__horizontalline:last').removeClass('hidden');
            $(".ph-helptopicscategories_questiontitle").removeClass('ph-helptopicscategories__questioncolorchange');
            $(".ph-helptopicscategories_questiontitle").removeClass('ph-helptopicscategories__uparrow');
            $(".ph-helptopicscategories_questiontitle").addClass('ph-helptopicscategories__downarrow');

            $(".ph-helptopicscategories_questiontitle").each(function(){
              if ($(this).children("mark").attr("data-markjs") === 'true') {
                $(this).parent().removeClass("hidden");
                $(this).removeClass('hidden');
              } else {
                $(this).addClass('hidden');
              }
            });
            
            $(".ph-helptopicscategories_answerdescription").each(function(){
              if ($(this).find("mark").attr("data-markjs") === 'true') {
                $(this).parent().removeClass("hidden");
                $(this).prev('.ph-helptopicscategories_questiontitle').removeClass('hidden');
              }
            });
            
          } else {
            $('.ph-helptopicscategories__boxes').removeClass('hidden');
            $('.ph-helptopicscategories__questions').addClass('hidden');
          }
        }
      });
    }
  }));
  
  $('.ph-supporthub__clear').on('click', function(){
    var markInstance = new Mark(document.querySelectorAll('.ph-helptopicscategories_questiontitle, .ph-helptopicscategories_answerdescription'));

    markInstance.unmark();

    $(".ph-supporthub__searchbottom").addClass('hidden');
    $('.ph-helptopicscategories__boxes').removeClass('hidden');
    $('.ph-helptopicscategories__questions').addClass('hidden');
    $('.ph-helptopicscategories_back').removeClass('hidden');
    $(".ph-helptopicscategories_questiontitle").removeClass('hidden');
    $('.ph-helptopicscategories_categoryname').removeClass('hidden');
    $(".ph-freetextsearch__input").val("");
  });
  
  $('.ph-savedlist__input').on('keyup', $.debounce(700, false,  function(){
    var textValue = $(document).find('.ph-savedlist__input').val(),
        markInstance = new Mark(document.querySelectorAll('.myshopping-list-names-tbl'));

    markInstance.unmark();
        
    if (textValue) {
      markInstance.mark(textValue, {
        caseSensitive: false,
        separateWordSearch: true,
        exclude: ['button'],
        done : function(mark){
          if (mark > 0) {
           
            $('.ph-noresult_listpage').addClass('hidden');
            $(".ph-panel-collapse").each(function(){
              if ($(this).find("mark").attr("data-markjs") === 'true') {
                $(this).addClass('ph-d-block');
                $(this).siblings(".ph-panel-heading").find('.ph-favarrow').removeClass('ph-icon-arrow-down').addClass('ph-icon-arrow-up');
                $(this).find('.ph-addfavcart').removeClass('ph-mylist__addtocart--disabled').removeAttr('disabled');
              } else {
                $(this).removeClass('ph-d-block');
                $(this).siblings(".ph-panel-heading").find('.ph-favarrow').removeClass('ph-icon-arrow-up').addClass('ph-icon-arrow-down');
	              $(this).find('.ph-addfavcart').addClass('ph-mylist__addtocart--disabled').attr('disabled');
              }
            });
                        
          } else {
            $(".ph-panel-collapse").each(function(){
              $(this).removeClass('ph-d-block');
              $(this).siblings(".ph-panel-heading").find('.ph-favarrow').removeClass('ph-icon-arrow-up').addClass('ph-icon-arrow-down');
              $(this).find('.ph-addfavcart').addClass('ph-mylist__addtocart--disabled').attr('disabled');
            });
            $('.ph-noresult_listpage').removeClass('hidden');
            }
        }
      });
    } else {
	$(".ph-panel-collapse").each(function(){
		$(this).removeClass('ph-d-block');
    $(this).siblings(".ph-panel-heading").find('.ph-favarrow').removeClass('ph-icon-arrow-up').addClass('ph-icon-arrow-down');
	  $(this).find('.ph-addfavcart').addClass('ph-mylist__addtocart--disabled').attr('disabled');
	});
  $('.ph-noresult_listpage').addClass('hidden');
	}
  }));

  $(document).on('click', '.ph-editshoppinglistpopup', function() {
    var markInstance = new Mark(document.querySelectorAll('.ph-editlistpopup'));
    markInstance.unmark();
  });

  $(document).on('click', '.ph-deleteshoppinglistpopup', function() {
    var markInstance = new Mark(document.querySelectorAll('.ph-deletelistpopup'));
    markInstance.unmark();
  });

  $(document).on('click', '.ph-noresult_cross', function() {
    $('.ph-noresult_listpage').addClass('hidden');
    $(document).find('.ph-savedlist__input').val('');
  });

  $('.ph-manageusers__freetextsearch--input').on('keyup', $.debounce(700, false, function() {
    var manageUsersFreeSearchWrapperClass = '.ph-manageusers__alldata--wrapper',
        manageUsersMarkInstance = new Mark(document.querySelectorAll(manageUsersFreeSearchWrapperClass));

    $(manageUsersFreeSearchWrapperClass).html('');
    $('.ph-oneStore__freeTextSearch--initialData, .ph-infinitescrollinitiated').attr('data-initiated', '-1');
    $(manageUsersFreeSearchWrapperClass).addClass('ph-manageUsers__freeSearch');
    $('.ph-manageusers__freeTextSearch--noResultsMain').addClass('hidden');
    $('.ph-intersection-observer').show();

    setTimeout(function () {
      ACC.searchmanageusers.setObserverSearchManageUsers(manageUsersMarkInstance);
    },1000);
  }));
});
